module.exports = __webpack_public_path__ + "img/nt85-00-82-1.asm.2fb2511f.jpg";